/*** IMPORTS FROM imports-loader ***/
var define = false;

import tagTester from './_tagTester.js';

export default tagTester('WeakSet');




//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isWeakSet.js
// module id = 166
// module chunks = 0